import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type QmaiProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Qmai = ({ size = 24, width, height, alt = '', style, ...props }: QmaiProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'matrix(1.11018596 0 0 1.11018596 2.04995837 1.45323342)',
        },
        [
          h(
            'g',
            {
            },
            [
              h(
                'g',
                {
                },
                [
                  h(
                    'path',
                    {
                      d: 'M8.93401 18.4858C4.01245 18.4544 0.00976562 14.4223 0.00976562 9.49918C0.00976562 4.5761 4.02497 0.514114 8.96062 0.514114C13.8963 0.514114 17.9115 4.54467 17.9115 9.49918C17.9115 11.4194 17.3151 13.2516 16.188 14.7963L11.999 14.7884L12.0256 14.7727C13.8697 13.6727 15.0155 11.652 15.0155 9.50076C15.0155 6.1286 12.298 3.38657 8.95905 3.38657C5.62009 3.38657 2.90416 6.12703 2.90416 9.49918C2.90416 12.8713 5.59348 15.5851 8.89957 15.6181H17.5577L17.5671 18.478L9.01071 18.4874H8.96062H8.93557L8.93401 18.4858Z',
                      fill: '#00E271',
                    },
                  ),
                  h(
                    'path',
                    {
                      d: 'M8.96025 0.522C13.8912 0.522 17.9033 4.54941 17.9033 9.49764C17.9033 11.4163 17.3084 13.2453 16.1829 14.79L12.0331 14.7774C13.8834 13.6743 15.0261 11.6614 15.0261 9.49764C15.0261 6.12078 12.3055 3.37403 8.96025 3.37403C5.61503 3.37403 2.89439 6.12235 2.89439 9.49921C2.89439 12.8761 5.58841 15.5945 8.8992 15.626H8.92894H17.5573V18.478H8.95868H8.93363C4.00268 18.445 0.0172192 14.4176 0.0172192 9.49921C0.0172192 4.58084 4.02929 0.522 8.96025 0.522ZM8.96025 0.504715C4.0199 0.504715 0 4.53998 0 9.49921C0 14.4584 4.00738 18.4639 8.93363 18.4953H8.95868H9.01034H17.5573H17.5745V15.6071H8.91172H8.8992C5.59781 15.5757 2.91161 12.8352 2.91161 9.49764C2.91161 6.16006 5.62442 3.39288 8.96025 3.39288C12.2961 3.39288 15.0073 6.13177 15.0073 9.49921C15.0073 11.6488 13.863 13.6665 12.0221 14.7649L11.9673 14.7979H12.0315L16.1814 14.8104H16.1907L16.1954 14.8026C17.3241 13.2563 17.9205 11.4226 17.9205 9.50078C17.9189 4.53998 13.9006 0.504715 8.96025 0.504715Z',
                      fill: '#00E271',
                    },
                  ),
                ],
              ),
            ],
          ),
        ],
      ),
    ],
  );

export default Qmai;
